import React from 'react';

import {Button, ChevronDownIcon, Content, DropDown, List, ListItem, Trigger} from '@kit';

import {useCharacter} from '../../character-context';
import {BASE_ITEM_CHOICE} from '../../model/equipment';
import {normalizeChoose} from '../../model/normalize-choose';
import {itemChoiceOptions} from '../../model/item-choice-options';
import type {SearchItem} from './use-item-search';

import css from '../sheet.module.css';

type Props = {
	item: SearchItem;
	children: React.ReactNode;
	icon?: React.ReactNode;
	/** основа, которую подставить без выбора, если предмет её допускает: опознаваемый длинный меч */
	preferredBaseId?: string;
	onPick(itemId: string, baseItemId?: string): void;
};

/** выбор найденного предмета; предмету с основой («Броня +1») основа выбирается в выпадающем списке */
export const ItemPickButton: React.FC<Props> = ({item, children, icon, preferredBaseId, onPick}) => {
	const {catalog} = useCharacter();
	const baseChoice = normalizeChoose(item.choose).find((group) => group.key === BASE_ITEM_CHOICE);
	const baseOptions = baseChoice ? itemChoiceOptions(baseChoice, catalog) : [];
	const hasPreferredBase = !!preferredBaseId && baseOptions.some((option) => option.value === preferredBaseId);

	if (!baseChoice || hasPreferredBase) {
		return (
			<Button
				size="small"
				icon={icon}
				onClick={() => onPick(item.id, hasPreferredBase ? preferredBaseId : undefined)}
			>
				{children}
			</Button>
		);
	}

	return (
		<DropDown
			selectMode="single"
			value={[]}
			onChange={([baseItemId]) => baseItemId && onPick(item.id, String(baseItemId))}
		>
			<Trigger>
				<Button size="small" icon={<ChevronDownIcon />} iconPosition="after">
					{children}
				</Button>
			</Trigger>
			<Content align="end" className={css.baseItemMenu}>
				<List aria-label={baseChoice.label || 'Основа'}>
					{baseOptions.map((option) => (
						<ListItem key={option.value} value={option.value}>
							{option.label}
						</ListItem>
					))}
				</List>
			</Content>
		</DropDown>
	);
};
